//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addServerPath } from "@/plugins/add-server-path";
import { extractContent } from "@/utils/helpers";
import IconView from "./IconView.vue";
import { Skeleton } from "ant-design-vue";
import { computeRenderIconOfProp, humanReadablePropValue } from "@/utils/converter.js";
import typo from "ru-typo";

export default {
  name: "WorkAreaWidget",
  components: {
    IconView,
    'a-skeleton': Skeleton
  },
  inject: ['source'],
  props: {
    description: {
      type: [Object, undefined],
    },
    object: {
      type: [Object, undefined],
    },
    id: {
      type: String
    },
    showClose: {
      type: Boolean,
      default: true
    },
    skeleton: {
      type: Boolean,
      default: false
    },
    getter: {}
  },
  computed: {
    computedDescription() {
      return this.skeleton ? { object: {} } : this.description
    },
    computedObject() {
      return this.skeleton ? { icon: {}, picto: {}, has_image: false, properties: [] } : this.object
    },
    text() {
      return typo(this.description?.text?.replaceAll('[SEP]', ''), { hyphens: true }) || typo(extractContent(this.object?.text)?.replaceAll('[SEP]', ''), { hyphens: true })
    },
    hasDescription() {
      return this.text || this.object
    },
    renderDescriptionTag() {
      return this.hasDescription && this.description?.object_id ? 'a' : 'div'
    },
    objectUrl() {
      let url = ""
      if (this.description) url = `/objects/${this.description?.object?.slug ?? this.description?.object?.relatedAttrId}/`
      if (this.description.attr_id) return `${url}${(this.source && this.source.length ? `?from=${this.source}` : '')}#${this.description.attr_id}`

      return url + (this.source && this.source.length ? `?from=${this.source}` : '')
    },
    mainProperties() {
      if (!Array.isArray(this.computedObject.properties)) return []
      return this.computedObject.properties.filter(x => x.is_main).map(prop => {
        prop.propHumanReadableValue = humanReadablePropValue(prop, this.$store.getters['objects/cachedObjectsGetter'], { reverseFullObject: false }).map(x => x.filter(i => i).join(', ')).join(', ')
        prop.renderCollectIcon = computeRenderIconOfProp(prop)
        return prop
      })
    },
    icon() {
      return this.computedObject.icon || this.computedObject.event_icon || this.computedObject.type?.icon
    }
  },
  methods: {
    addServerPath,
  }
}
